import { useState } from 'react';

const reminders = [
  { id: 'rem-1', label: '每日深扒长图更新' },
  { id: 'rem-2', label: '时间线节点变动' },
  { id: 'rem-3', label: '评论区高赞补充' },
];

export default function SubscribeBand() {
  const [on, setOn] = useState<Record<string, boolean>>({ 'rem-1': true, 'rem-2': true });

  return (
    <section id="subscribe" className="w-full bg-primary-500">
      <div className="px-4 md:px-6 lg:px-10 py-12 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-6">
            <span className="inline-flex items-center gap-2 h-7 px-3 rounded-full bg-primary-600/60 text-background-50 text-xs font-label">
              <i className="ri-notification-3-line"></i>
              深扒提醒
            </span>
            <h2 className="mt-5 font-heading text-2xl md:text-3xl font-bold text-background-50 leading-snug">
              把想跟的线索钉在这里，更新一次也不落
            </h2>
            <p className="mt-3 text-sm text-background-50/85 max-w-xl leading-relaxed font-body">
              选择你关心的更新类型，新的黑料图文深扒长图、时间线节点与评论补充出现时，都会归到同一条线索下。
            </p>
          </div>

          <div className="lg:col-span-6">
            <div className="rounded-lg bg-background-50 p-5 md:p-6">
              <p className="text-xs tracking-[0.2em] text-foreground-500 font-label">提醒类型</p>
              <div className="mt-4 space-y-3">
                {reminders.map((item) => {
                  const active = !!on[item.id];
                  return (
                    <button
                      key={item.id}
                      type="button"
                      onClick={() => setOn((prev) => ({ ...prev, [item.id]: !prev[item.id] }))}
                      className={`w-full flex items-center justify-between gap-4 rounded-md border px-4 py-3 transition-colors cursor-pointer ${
                        active ? 'border-primary-300 bg-primary-100/60' : 'border-background-300 bg-background-100'
                      }`}
                    >
                      <span className={`text-sm font-label ${active ? 'text-primary-800' : 'text-foreground-700'}`}>{item.label}</span>
                      <span className={`relative w-10 shrink-0 rounded-full transition-colors ${active ? 'bg-primary-500' : 'bg-background-300'}`} style={{ height: '22px' }}>
                        <span className={`absolute top-[3px] w-4 h-4 rounded-full bg-background-50 transition-all ${active ? 'left-[21px]' : 'left-[3px]'}`}></span>
                      </span>
                    </button>
                  );
                })}
              </div>
              <div className="mt-5 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
                <a
                  href="#topics"
                  className="h-11 px-6 flex items-center justify-center rounded-md bg-foreground-950 text-background-50 text-sm font-label font-medium whitespace-nowrap hover:bg-foreground-800 transition-colors"
                >
                  去话题墙挑线索
                </a>
                <span className="text-xs text-foreground-500 font-label sm:pl-2">
                  已开启 {Object.values(on).filter(Boolean).length} 项提醒
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}